import { Component } from '@angular/core';
import { FieldArrayType } from '@ngx-formly/core';

@Component({
  selector: 'formly-repeat-section',
  template: `
    <div *ngFor="let field of field.fieldGroup; let i = index;" class="row">
      <formly-field class="col" [field]="field"></formly-field>
      <div class="col-sm-2 d-flex align-items-center">
        <button class="btn btn-sibasi-secondary" type="button" (click)="remove(i)">
          <i class="fas fa-minus"></i>
          Remove
        </button>
      </div>
    </div>
    <div style="margin:30px 0;">
      <button class="btn btn-sibasi-primary" type="button" (click)="add()">
        <i class="fas fa-plus"></i>
        {{ to.addText }}
      </button>
    </div>
  `,
})
export class RepeatTypeComponent extends FieldArrayType {}
